export const SHOW_SUCCESS_INFO_MODAL = "show-success-info-modal";
export const SHOW_ERROR_INFO_MODAL = "show-error-info-modal";
export const SHOW_CONFIRM_INFO_MODAL = "show-confirm-info-modal";
